import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { loadState, saveState } from "./localStorage";
import throttle from "lodash.throttle";
import cartReducer from "./features/cartSlice";
import pollReducer from "./features/pollSlice";
import { branchApi } from "./api/branchApi";
import { userApi } from "./api/userApi";
import { productApi } from "./api/productApi";
import { orderApi } from "./api/orderApi";
import { paymentApi } from "./api/paymentApi";
import { tinybirdApi } from "./api/tinybirdApi";

const persistedState = loadState();
const middlewares = [
  branchApi.middleware,
  userApi.middleware,
  productApi.middleware,
  orderApi.middleware,
  paymentApi.middleware,
  tinybirdApi.middleware,
];

const store = configureStore({
  reducer: combineReducers({
    cart: cartReducer,
    [branchApi.reducerPath]: branchApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [tinybirdApi.reducerPath]: tinybirdApi.reducer,
    poll: pollReducer,
  }),
  preloadedState: persistedState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(middlewares),
});

store.subscribe(
  throttle(() => {
    saveState({
      cart: store.getState().cart,
    });
  }, 1000),
);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
